/* MERENUS — global.js */
(function () {
  'use strict';

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  window.MerenusTheme = { formatMoney: formatMoney };

  /* ---------- Helpers ---------- */
  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function setBodyFlag(flag, on) {
    document.body.classList.toggle(flag, on);
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = qs('#MobileMenu');
  if (mobileMenu) {
    qsa('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileMenu.classList.add('is-open');
        setBodyFlag('menu-open', true);
        var first = qs('[data-panel="0"] .mobile-menu__link', mobileMenu);
        if (first) first.focus();
      });
    });
    qsa('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        setBodyFlag('menu-open', false);
      });
    });
    qsa('[data-submenu-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-submenu-open');
        var panel = qs('[data-panel="' + id + '"]', mobileMenu);
        if (panel) {
          qsa('.mobile-menu__panel', mobileMenu).forEach(function (p) { p.classList.remove('is-active'); });
          panel.classList.add('is-active');
        }
      });
    });
    qsa('[data-submenu-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('.mobile-menu__panel', mobileMenu).forEach(function (p) { p.classList.remove('is-active'); });
        var root = qs('[data-panel="0"]', mobileMenu);
        if (root) root.classList.add('is-active');
      });
    });
  }

  /* ---------- Search modal ---------- */
  var searchModal = qs('#SearchModal');
  if (searchModal) {
    qsa('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        searchModal.classList.add('is-open');
        setBodyFlag('search-open', true);
        var input = qs('input[type="search"]', searchModal);
        if (input) setTimeout(function () { input.focus(); }, 120);
      });
    });
    qsa('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        searchModal.classList.remove('is-open');
        setBodyFlag('search-open', false);
      });
    });
  }

  /* ---------- Overlay closes everything ---------- */
  var overlay = qs('#PageOverlay');
  if (overlay) {
    overlay.addEventListener('click', function () {
      setBodyFlag('drawer-open', false);
      setBodyFlag('menu-open', false);
      setBodyFlag('search-open', false);
      if (cartDrawerEl) cartDrawerEl.classList.remove('is-open');
      if (mobileMenu) mobileMenu.classList.remove('is-open');
      if (searchModal) searchModal.classList.remove('is-open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setBodyFlag('drawer-open', false);
    setBodyFlag('menu-open', false);
    setBodyFlag('search-open', false);
    if (cartDrawerEl) cartDrawerEl.classList.remove('is-open');
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (searchModal) searchModal.classList.remove('is-open');
  });

  /* ---------- Cart ---------- */
  var cartDrawerEl = qs('#CartDrawer');

  function fetchCart() {
    return fetch(window.theme.routes.cart + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* Line item properties are customer-supplied and get injected as HTML, so
     they have to be escaped before they go anywhere near innerHTML. */
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function propertyLines(item) {
    if (!item.properties) return '';
    return Object.keys(item.properties).reduce(function (html, key) {
      var value = item.properties[key];
      if (value === '' || value === null || value === undefined) return html;
      return html + '<div class="cart-item__meta">' + escapeHtml(key) + ': ' + escapeHtml(value) + '</div>';
    }, '');
  }

  function renderCartDrawer(cart) {
    if (!cartDrawerEl) return;
    var itemsEl = qs('[data-cart-items]', cartDrawerEl);
    var emptyEl = qs('[data-cart-empty]', cartDrawerEl);
    var footerEl = qs('[data-cart-footer]', cartDrawerEl);
    var subtotalEl = qs('[data-cart-subtotal]', cartDrawerEl);

    if (!cart.items.length) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      if (footerEl) footerEl.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = '';
      var html = '';
      cart.items.forEach(function (item, index) {
        var line = index + 1;
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_180x$1$2') + '" alt="" loading="lazy">'
          : '';
        var options = (item.options_with_values || [])
          .filter(function (o) { return o.value; })
          .map(function (o) { return '<div class="cart-item__meta">' + o.name + ': ' + o.value + '</div>'; })
          .join('');
        html +=
          '<div class="cart-item" data-line="' + line + '">' +
            '<a href="' + item.url + '" class="cart-item__image">' + img + '</a>' +
            '<div>' +
              '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
              options +
              propertyLines(item) +
              (item.final_price !== item.original_price
                ? '<div class="cart-item__price"><s>' + formatMoney(item.original_price) + '</s> ' + formatMoney(item.final_price) + '</div>'
                : '<div class="cart-item__price">' + formatMoney(item.original_price) + '</div>') +
            '</div>' +
            '<div class="cart-item__total">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-item__controls">' +
              '<div class="qty">' +
                '<button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
                '<input type="number" min="0" value="' + item.quantity + '" data-qty-input aria-label="Quantity">' +
                '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-line-remove aria-label="Remove">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>';
      });
      if (itemsEl) itemsEl.innerHTML = html;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
    updateCartCount(cart.item_count);
  }

  function openCartDrawer() {
    if (!cartDrawerEl) { window.location.href = window.theme.routes.cart; return; }
    cartDrawerEl.classList.add('is-open');
    setBodyFlag('drawer-open', true);
  }

  function refreshCart(open) {
    return fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      if (open) openCartDrawer();
      return cart;
    });
  }

  function changeLine(line, quantity) {
    return fetch(window.theme.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(false); });
  }

  function addToCart(data) {
    return fetch(window.theme.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    }).then(function () { return refreshCart(true); });
  }

  /* Delegated events inside drawer */
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-line-remove]');
      var item = e.target.closest('.cart-item');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = qs('[data-qty-input]', item);
      var qty = parseInt(input.value, 10) || 1;
      if (minus) changeLine(line, Math.max(0, qty - 1));
      else if (plus) changeLine(line, qty + 1);
      else if (remove) changeLine(line, 0);
    });
    cartDrawerEl.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var item = e.target.closest('.cart-item');
      var line = parseInt(item.getAttribute('data-line'), 10);
      var qty = parseInt(e.target.value, 10);
      if (isNaN(qty) || qty < 0) qty = 1;
      changeLine(line, qty);
    });
    qsa('[data-cart-close]', cartDrawerEl).forEach(function (btn) {
      btn.addEventListener('click', function () {
        cartDrawerEl.classList.remove('is-open');
        setBodyFlag('drawer-open', false);
      });
    });
  }

  qsa('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart(false).then(openCartDrawer);
    });
  });

  /* Line item properties (`properties[Wrist size]` and friends) have to be
     copied off the form by hand — the AJAX add uses a slim payload that only
     carries the variant id, so anything the customer typed would be dropped. */
  function lineProperties(form) {
    var props = {};
    new FormData(form).forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && String(value).trim() !== '') props[match[1]] = value;
    });
    return Object.keys(props).length ? props : null;
  }

  /* Add to cart forms (product page, quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = qs('[type="submit"]', form);
    if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }
    var formData = new FormData(form);
    var item = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity'), 10) || 1
    };
    var props = lineProperties(form);
    if (props) item.properties = props;
    var data = { items: [item] };
    addToCart(data).catch(function (err) {
      alert(err.description || err.message || 'Unable to add to cart');
    }).finally(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); }
    });
  });

  /* Buy-it-now: add then go straight to checkout */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    var id = new FormData(form).get('id');
    var buyNowItem = { id: id, quantity: 1 };
    var buyNowProps = lineProperties(form);
    if (buyNowProps) buyNowItem.properties = buyNowProps;
    addToCart({ items: [buyNowItem] })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        alert(err.description || err.message || 'Unable to add to cart');
      });
  });

  /* Initial render */
  document.addEventListener('DOMContentLoaded', function () {
    refreshCart(false);
  });
})();
